export default __webpack_public_path__ + "6ff785f62de02ff5fdf8a82627e659a7.png";